import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartial from './FormPartial.js';
import Scheme from '../../models/Scheme.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const Edit = (props) => {
  
  const navigate = useNavigate();
  const schemeObj = new Scheme();
  const [scheme, setScheme] = useState(schemeObj.toStateJson());
  const [fetchApi] = getApi('showScheme');
  const [updateApi] = getApi('updateScheme');

  const params = useParams();

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setScheme((new Scheme(response.data.scheme)).toStateJson());
    } catch(error) {
      toast.error("Something went wrong !");
    }
  }

  const updateRecord = async (params) => {
    try {
      let response = await updateApi(params).unwrap();
      if (response.message === "updated"){
        navigate('/schemes');
      }
    } catch(error) {
      schemeObj.set_api_errors(error.data.data.errors);
      setScheme(schemeObj.toStateJson());
    }
  }
  
  useEffect(() => {
    getRecord({ id: params.id })
  }, []);


  const handleSubmitFunction = () => {
    try{
      updateRecord((new Scheme(scheme)).toApiJson());
    } catch(error){
      setScheme(new Scheme(scheme));
    }
  }

  const handleCancelFunction = () => {
    navigate('/schemes');
  }

  return (
    <Page
      uiPage={uiManager.getUiPage(PAGES.EditSchemePage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "Scheme List", url: '/schemes'}, { label: "Edit Scheme" }]}
      className={'edit-scheme-page'}
    >
      <PageContentWrapper contentHeading={"Edit Scheme"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <FormPartial scheme={scheme} setScheme={setScheme} />
              <div className='mb-4 col-md-12'>
                <div >
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Update Scheme</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
  );

}

export default Edit;